<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<Button
						:label="$t('processamentosPrognose')"
						color="trv-primary"
						outlined
						semantic-class="tiny"
						width-auto
						@click="$router.push('/prognose/processamentos')"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.codigo }} - {{ $t('descricao') }} : {{ item.descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<div class="container__crudactions__cruddownload__download">
					<!-- <DownloadButton /> -->
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						@click="downloadCSVPrognose()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<InputText
					v-model="model.descricao"
					:label="$t('description')"
					@input="onDescriptionChange"
				/>
				<DropdownFk
					v-model="model.classificacaoDeSitioId"
					:label="$t('siteClassification')"
					:dropdown-options="classificacoes"
					:disabled="isEdit"
				/>
				<!-- Sem :value duplicado: ele sobrescrevia o v-model e o dropdown exibia
				     SEMPRE o computed variaveisBiometricas (tudo marcado), ignorando as
				     escolhas preparadas no visualizar/editar. -->
				<DropdownCheckbox
					id="dropdown_variaveis_biometricas"
					v-model="variaveisEscolhidas"
					:label="$t('biometricVariables')"
					full-width
					full-width-list
					:readonly="isEdit"
				/>
				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('planning')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="goToPlanejamento()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
					<Button
						v-if="descriptionChanged"
						:label="$t('save')"
						color="trv-default"
						@click="update"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import { getAllClassificacaoSitio } from '../../../services/requests/ClassificacaoSitioRequests'
import {
	deletePrognoseByIdList,
	getAllPrognose,
	updatePrognose,
} from '../../../services/requests/PrognoseRequests'

import { prognose } from '../../../utils/variaveisBiometricas'

import { exportarCsv } from '../../../utils/csvHellpers'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		DropdownCheckbox,
		DropdownFk,
		InputSearch,
		InputText,
		Pagination,
		KebabMenu,
		ExclusionAlert,
	},
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			descriptionChanged: false,
			showExclusionAlert: false,
			initialDescription: '',
			intention: {},
			headersSelecionados: ['descricao', 'codigo', 'dataDaPrognose'],
			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{ key: 'descricao', value: this.$t('description'), isActive: true },
				{
					key: 'dataDaPrognose',
					value: this.$t('prognosisDate'),
					isActive: true,
				},
			],
			variaveisEscolhidas: prognose.map((m) => {
				return {
					value: `${m.acronimo} - ${m.label}`,
					key: m.value,
					isActive: true,
				}
			}),
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				// clst_cd_codigo: "",
				descricao: '',
				// prog_dt_data: "",
			},
			classificacoes: [],
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'PROG',
				subtitleCardPropertie: 'descricao',
				titleCardPropertie: 'codigo',
			},
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('toView'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		variaveisBiometricas() {
			return prognose.map((m) => {
				return {
					value: `${m.acronimo} - ${m.label}`,
					key: m.value,
					isActive: true,
				}
			})
			// return prognose;
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.descricao
		},
	},
	/**
	 * Método executado quando clica no botão de salvar
	 */
	saveClick() {
		this.disableSaveButton = true
		if (this.isEdit) {
			this.update()
		} else {
			this.create()
		}
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	created() {
		this.model.variaveisBiometricas = this.variaveisBiometricas
		this.quantityPerPage = 10
		// this.orderTable = ["prog_dt_data"];
		getAllPrognose().then(async (response) => {
			var { data: prognose } = response

			prognose = await prognose.sort((a, b) =>
				new Date(a.dataDaPrognose).getTime() > new Date(b.dataDaPrognose).getTime() ? -1 : 1,
			)
			const totalRegistros = prognose.length
			prognose.forEach((prognose, index) =>
				this.formataPrognoseParaTabela(prognose, index, totalRegistros),
			)
			this.modelList = prognose
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getAllClassificacaoSitio().then((response) => {
			const result = response.data
			const sortedResult = result.sort((a, b) =>
				new Date(a.dataDaClassificacao).getTime() > new Date(b.dataDaClassificacao).getTime()
					? -1
					: 1,
			)
			const totalRegistros = sortedResult.length
			this.classificacoes = sortedResult.map((m, index) => {
				const codigo = `CS-${String(totalRegistros - index).padStart(2, '0')}`
				return {
					[this.$t('code')]: codigo,
					[this.$t('description')]: m.descricao,
					[this.$t('reference')]: `${m.idadeDeReferencia} ${this.$t('months')}`,
					[this.$t('model')]: m.nomeDoModelo,
					[this.$t('sites')]: m.quantidadeDeSitios,
					[this.$t('date')]: new Date(m.dataDaClassificacao).toLocaleString(),
					id: m.id,
				}
			})
		})
	},

	/**
	 * Configura para exibir o Model de Cadastro
	 */

	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.descricao !== value
				this.disableSaveButton = true
			} else {
				this.disableSaveButton = false
			}
		},
		goToPlanejamento() {
			let variaveis = this.variaveisEscolhidas.filter((f) => f.isActive).map((m) => m.key)
			this.model.variaveisBiometricas = prognose.filter((f) => variaveis.includes(f.value))
			localStorage.setItem('isEdit', this.isEdit)
			localStorage.setItem('item-planejamento-prognose', JSON.stringify(this.model))
			// localStorage.setItem("item-planejamento-classificacao", JSON.stringify(this.model));
			this.$router.push(`/prognose/planejamento/${this.model.id}`)
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			let variaveis = model.analisesEstatisticas.map((m) => m.variavelDeInteresse)

			this.variaveisEscolhidas = prognose.map((m) => {
				return {
					value: `${m.acronimo} - ${m.label}`,
					key: m.value,
					// O salvo carrega o ENUM ("AlturaDominante") — comparar com o label
					// traduzido nunca batia e o dropdown vinha sem as escolhas marcadas.
					// O label fica como fallback para registros antigos.
					isActive: variaveis.includes(m.enum) || variaveis.includes(m.label),
				}
			})

			this.titleForm = `${this.$t('toView')} ${this.$t('prognosis')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},
		/**
		 * Exclui estrato inventario cubagem no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const confirmResult = confirm('Deseja realmente excluir esses registros?')

				if (confirmResult) {
					deletePrognoseByIdList({ ids: this.modelsIdWithCheckedToDelete })
						.then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
						.catch((error) => {
							this.mutationShowMessage({
								messageTitle: 'Atenção!',
								messageIcon: 'far fa-times-circle',
								messageType: 'error',
								messageText: error.response.data.errors.Mensagens[0],
							})
						})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.model.id = uuidv4()
			this.titleForm = `${this.$t('create')} ${this.$t('prognosis')}`
			this.isEdit = false
			this.variaveisEscolhidas = this.variaveisBiometricas
			this.changeFormAndCloseAllActions()
			console.log(this.model)
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.descriptionChanged = false
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataPrognoseParaTabela(prognose, index, totalRegistros) {
			prognose.isCheckedToDelete = false
			prognose.dataDaPrognose = prognose.dataDaPrognose
				? new Date(prognose.dataDaPrognose).toLocaleDateString()
				: ''
			prognose.codigo = `PR-${String(totalRegistros - index).padStart(2, '0')}`
		},

		update() {
			updatePrognose({
				Id: this.model.id,
				Descricao: this.model.descricao,
			})
				.then(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})

					this.showForm = false
					this.descriptionChanged = false
					window.location.reload()
				})
				.catch(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('erroAoAtualizarPrognose'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},

		/**
		 * Baixa a tabela prognose em CSV
		 */
		downloadCSVPrognose() {
			let cabecalhoDoCsvPrognose = ['Código', 'Descrição', 'Data da Prognose']
			const items = this.modelList

			const linhas = items.map((item) => [item.codigo, item.descricao, item.dataDaPrognose])

			exportarCsv('export_prognose', cabecalhoDoCsvPrognose, linhas)
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>

<style scoped>
#dropdown_variaveis_biometricas {
	margin-top: 1rem;
}
</style>
